/**
 * Para este proyecto se usa la fuente Motserrat, este modulo
 * descarga los archivos de las fuentes en el momento de la compilación
 * y los aloja con el resto de los recursos estáticos.
 * */ 

import { Montserrat, Lato } from 'next/font/google';

// selecciona el subconjunto de una fuente a usar.
export const montserrat = Montserrat({
     subsets: ['latin'],
     display: 'swap',
     weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
 });

export const lato = Lato({ 
    subsets: ['latin'], 
    weight: ["400", "700", "900"], 
});